import { FC } from 'react';

import { DeepLinkType } from '@gem/models/deeplinksModel';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { useDeepLinkViewActionPresenter } from './DeepLinkViewAction.presenter';
import styles from './DeepLinkViewAction.styles.m.css';

interface IDeepLinkViewActionProps {
  deepLinkType: DeepLinkType;
  appLink: string;
  isDisabled: boolean;
}

export const DeepLinkViewAction: FC<IDeepLinkViewActionProps> = (props) => {
  const { deepLinkType, appLink, isDisabled } = props;
  const { t } = useTranslation();
  const presenter = useDeepLinkViewActionPresenter({ deepLinkType, appLink });

  return (
    <UnauthorizedLayoutTemplate
      title={presenter.title}
      subtitle={presenter.subtitle}
    >
      <div className={styles.content}>
        {!!appLink && (
          <Button
            isDisabled={isDisabled}
            className={styles.mainAction}
            size="30"
            theme="primary"
            onClick={presenter.onMainActionClick}
          >
            {t('common_open_app')}
          </Button>
        )}
      </div>
    </UnauthorizedLayoutTemplate>
  );
};
